import { matchPath } from 'react-router-dom'

export const RESERVED_TOP_SEGMENTS = new Set<string>([
  'dashboard',
  'admin',
  // Federated remotes: /onboarding/terms is a sign-up step, never the old terms tab of an STO.
  'invest',
  'onboarding',
  'solutions',
  'featured-assets',
  'login',
  'signup',
  'setup-2fa',
  'manage-user',
  'careers',
  'press-releases',
  'legal-hub',
  'privacy',
  'terms',
  'team',
  'cookies-policy',
  'stoke-post',
  '101',
  'hiring',
  '404',
  'under-construction',
  'newsletter',
  'spam-report',
  'page-not-found',
  // Legacy redirect routes (routes.tsx -> <Navigate>). Reserved so SSR does not
  // treat them as STO slugs and 404 them — that would break old inbound links
  // and drop the redirect. reservedRoutes.test.ts guards this list.
  'legal',
  'cookie-policy',
  'conflicts-of-interest',
  'complaints',
  'whistleblowing',
])

/**
 * True when the path sits under a reserved section but matches none of its routes
 * (e.g. /101/old-page). The client shows PageNotFound there, so SSR must answer 404
 * instead of a 200 soft 404.
 */
export const isUnknownReservedPath = (pathname: string, routePaths: string[]): boolean => {
  const path = pathname.split('?')[0]
  const top = path.replace(/^\/+/, '').split('/')[0]
  if (!RESERVED_TOP_SEGMENTS.has(top)) return false
  return !routePaths.some((pattern) => pattern !== '*' && matchPath(pattern, path))
}
